import { render } from "./IfBlockComponent.vue?vue&type=template&id=e5526f8c&scoped=true"
import script from "./IfBlockComponent.vue?vue&type=script&lang=js"
export * from "./IfBlockComponent.vue?vue&type=script&lang=js"

import "./IfBlockComponent.vue?vue&type=style&index=0&id=e5526f8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5526f8c"

export default script